























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ListeTuilePres from '@/components/shared/ListeTuilePres.vue'
import ListeTuileCours from '@/components/shared/ListeTuileCours.vue'
import PiscineTarifs from '@/components/piscines/PiscineTarifs.vue'

import { ITuileNav } from '@/models/ui/ITuileNav'
//@ts-ignore
import L from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip,LPolygon } from 'vue2-leaflet'
import { latLng } from "leaflet"
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { getImageUrl } from '@/utils/images'
import { ConvertToTuileNav } from '@/models/alo/AloActivity'
import { getDefaultAloMedia } from '@/models/alo/AloMedia'
import { AloForfait } from '@/models/alo/AloForfait'
import { AloInscription } from '@/models/alo/AloInscription'
import { formatDate } from '@/filters/formatDate'
import { formatCurrency } from '@/filters/currency'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { toNumberDictionary } from '@/utils/groupBy'
import { AloCours } from '@/models/alo/AloCours'
import { StatusInscription } from '@/enum/StatusInscription'
import { AlsCours } from '@/models/als/AlsCours'
import moment from 'moment'
import { CommitAction } from '@/enum/CommitAction'
import {zoneDomicile} from '@/models/ZoneDomicile'

@Component({
  name:'DetailPiscine',
  props:{
    slug:{
      type:String,
      default:""
    },
    piscineId:{
      type:Number,      
      default:0
    }
  },
  components: { 
    ListeTuilePres,
    ListeTuileCours,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    PiscineTarifs 
  },
})
export default class DetailPiscine extends Vue {
  
  private slug!:string
  private piscineId!:number

  private calendly = 'aquadomic'
  private renderCalendly = true

  setCalendly(calendly:string){
    this.renderCalendly = false
    this.calendly = calendly    
    this.$nextTick(()=> this.renderCalendly = true)
  }


  private nbSemaineGlissante = 6
  private zoom = 13
  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  private attribution ='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

  private domicileLatLngs = [[43.159686,5.954666],[43.160308,5.955219],[43.160506,5.955007],[43.161522,5.955131],[43.16203,5.954935],[43.162274,5.954514],[43.162773,5.953975],[43.162787,5.95331],[43.163001,5.952831],[43.163646,5.953024],[43.164322,5.953755],[43.164913,5.954606],[43.165028,5.955424],[43.16561,5.95621],[43.165038,5.957233],[43.166483,5.958639],[43.16671,5.959553],[43.166846,5.961048],[43.166755,5.962292],[43.167456,5.965039],[43.167692,5.968785],[43.168029,5.97116],[43.16404,5.984936],[43.17335,5.9883],[43.173431,5.989692],[43.173382,5.990077],[43.173637,5.990703],[43.174856,5.989914],[43.175468,5.989953],[43.17598,5.990148],[43.175911,5.989464],[43.176172,5.98904],[43.176865,5.988544],[43.178014,5.988077],[43.178825,5.987538],[43.183599,5.981295],[43.183385,5.980985],[43.183877,5.980326],[43.187918,5.977942],[43.188678,5.977688],[43.191759,5.978537],[43.19389,5.973769],[43.194975,5.97295],[43.19608,5.973205],[43.196094,5.972833],[43.196527,5.97178],[43.197032,5.97063],[43.197247,5.969922],[43.197175,5.968002],[43.197423,5.965569],[43.197581,5.96513],[43.198904,5.962852],[43.200078,5.960917],[43.205499,5.954997],[43.20585,5.954834],[43.206176,5.954478],[43.20644,5.953767],[43.206627,5.953539],[43.209488,5.946185],[43.210508,5.945027],[43.21064,5.945048],[43.212169,5.943366],[43.212398,5.943247],[43.214672,5.940705],[43.215934,5.939428],[43.203548,5.934],[43.203116,5.933878],[43.20271,5.933193],[43.202302,5.932711],[43.201536,5.931429],[43.200032,5.929802],[43.195526,5.925297],[43.195165,5.924975],[43.194854,5.924458],[43.194649,5.924386],[43.194271,5.923614],[43.193572,5.923101],[43.19314,5.922915],[43.190244,5.918884],[43.190542,5.918379],[43.190494,5.917695],[43.190602,5.91731],[43.190989,5.917005],[43.190915,5.91661],[43.185371,5.908856],[43.185097,5.907994],[43.184989,5.907891],[43.18494,5.907213],[43.184703,5.906924],[43.184847,5.906481],[43.184721,5.905948],[43.184471,5.905574],[43.184084,5.905587],[43.183699,5.904506],[43.183771,5.903806],[43.183496,5.902793],[43.183427,5.902025],[43.182911,5.899995],[43.181602,5.900059],[43.180601,5.900566],[43.179773,5.900788],[43.179407,5.901226],[43.178729,5.901642],[43.178483,5.90207],[43.178047,5.902582],[43.177219,5.902539],[43.176703,5.902649],[43.175321,5.902405],[43.174057,5.90261],[43.173734,5.902504],[43.173199,5.902642],[43.172666,5.902248],[43.172084,5.902176],[43.171676,5.902442],[43.170689,5.903365],[43.169972,5.904715],[43.169631,5.905641],[43.168412,5.906427],[43.16811,5.906765],[43.16753,5.907685],[43.167246,5.90848],[43.16761,5.90954],[43.167197,5.910228],[43.16739,5.910677],[43.167109,5.911028],[43.166515,5.911248],[43.165874,5.913002],[43.166782,5.914134],[43.165785,5.914708],[43.165825,5.914938],[43.165341,5.916656],[43.165114,5.91696],[43.164568,5.917154],[43.16419,5.917517],[43.16487,5.918192],[43.163973,5.920605],[43.163258,5.920388],[43.163049,5.920663],[43.163104,5.923674],[43.163354,5.927185],[43.163011,5.927944],[43.163005,5.92858],[43.163435,5.930327],[43.163807,5.931191],[43.163942,5.9321],[43.164159,5.932928],[43.165086,5.935199],[43.165318,5.936923],[43.165336,5.93817],[43.165112,5.939403],[43.164687,5.940362],[43.164717,5.940726],[43.164365,5.941972],[43.164366,5.942742],[43.163985,5.943798],[43.163693,5.945268],[43.163395,5.946326],[43.163145,5.948474],[43.162612,5.949522],[43.162509,5.949603],[43.162301,5.950523],[43.162113,5.950975],[43.161541,5.951633],[43.160711,5.953156],[43.159686,5.954666]]

  get center(){
    return [this.piscine.address.gpsLat!,this.piscine.address.gpsLon!]
  } 
  get marker(){
    return latLng(this.piscine.address.gpsLat!,this.piscine.address.gpsLon!)  
  } 
  private psnId:number = 0
  private loading = true  
  private loadingCours = true  
  private showAcyPlanningFilter = false 
  private showAcyTarifFilter = false
  private date1 = new Date().toISOString().substr(0, 10)  
  private min = new Date().toISOString().substr(0, 10)
  private acyIdPlanning:number = -1
  private acyIdTarif:number = -1
  private coursIds:Array<number> = []

  @Watch("psnId")
  onPsnIdChange(){
    this.loadPiscine()
  }

  @Watch("slug")
  onSlugChange(){
    this.loadPiscine()
  }
  
  get getImageUrl(){ 
    return getImageUrl
  }

  get zoneDomicile(){
    return zoneDomicile
  }

  get twoLine(){
    return this.piscine.content.pctSubTitle.length != this.subTitleHtml.length
  }

  get subTitleHtml(){
    return this.piscine.content.pctSubTitle.replace('\n','<br/>')
  }  

  get piscine(){
    return this.$store.myGetters.piscineDic[this.psnId] || getDefaultAloPiscine()
  }

  get imageSliderUrl() {
    return getImageUrl(this.piscine.image,1920,700,"crop")
  }

  get imageDetailUrl() {
    return getImageUrl(this.piscine.image,580,400,"crop")
  }

  get max()
  {    
    return new Date(moment.utc().add(this.nbSemaineGlissante,"week").toDate()).toISOString().substring(0, 10)
  } 

  private get coursDic() {
    return this.$store.myGetters.coursDic
  } 

  get piscineCours() {
    return this.coursIds.map(id => this.coursDic[id])
  }  

  get cours() {
    return this.piscineCours.filter(c => this.acyIdPlanning == -1 || c.acyId == this.acyIdPlanning || c.acyIdCplt == this.acyIdPlanning).sort((a,b) => a.crsDatdebut.localeCompare(b.crsDatdebut) )
  }  

  private get activitiesItems(){
     return this.activityPiscineList.map(acy => ConvertToTuileNav(acy))
  }

  get calendarCours(){
    return this.cours.filter(c => c.crsDatdebut.substr(0, 10) == this.date1)
  }

  get resas(){
     return this.calendarCours.reduce((resas,cours)=>{
       resas.push(...cours.inscriptions.filter(i => i.famId == this.$store.myGetters.user.famId && i.isnStatus <= StatusInscription.abscent).map(r => r.crsId))
       return resas
     },[] as Array<number>)          
  }

  get mesResa(){
     return this.piscineCours.filter(c => c.inscriptions.some(i => i.famId == this.$store.myGetters.user.famId && i.isnStatus <= StatusInscription.abscent)).map(c => formatDate(c.crsDatdebut,"YYYY-MM-DD"))
  }

  get selectedAcyPlanning(){
    return this.$store.myGetters.activityDic[this.acyIdPlanning]?.libelle ?? "Toutes"
  }

  get selectedAcyTarif(){
    return this.$store.myGetters.activityDic[this.acyIdTarif]?.libelle ?? "Toutes"
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get activityPiscineList(){
    return this.piscine.acyIds.filter(acyId => !!this.activityDic[acyId]).map(acyId => this.activityDic[acyId])
  }  
  get activityListWithCours(){
    return this.$store.myGetters.activityList.filter(a => this.piscineCours.some(c => c.acyId == a.id || c.acyIdCplt == a.id))
  }  

  get activityDictWithCours(){
    return toNumberDictionary(this.activityListWithCours,a => a.id)
  }

  get forfaitDic(){
    return this.$store.myGetters.forfaitDic
  }

  private get arianeItems(){
     return [
        {
          text: 'Accueil',
          disabled: false,
          to: {name:'Home'},    
          exact:true      
        },
        {
          text: 'Trouver votre piscine',
          disabled: false,
          to: {name:'Piscines'},
          exact:true
        },
        {
          text: this.piscine.libelle,
          disabled: true          
        },
    ]
  }

  get forfaitPiscine(){
    return this.piscine.fftIds.map(fftId => this.forfaitDic[fftId]).filter(f => f.fftEnable && (this.acyIdTarif == -1 || (f.acyIds.filter(id => this.piscine.acyIds.indexOf(id)>-1).indexOf(this.acyIdTarif) > -1))).sort((a,b) =>{ return (this.activityDic[a.acyIds[0]]?.acyOrdre??Number.MAX_VALUE) - (this.activityDic[b.acyIds[0]]?.acyOrdre??Number.MAX_VALUE) })
  }

  get forfaitPiscineEnfant(){
    return this.forfaitPiscine.filter(f => this.activityDic[f.acyIds[0]]?.acyEnfant)
  }

  get forfaitPiscineAdulte(){
    return this.forfaitPiscine.filter(f => !this.activityDic[f.acyIds[0]]?.acyEnfant)
  }

  created(){    
    this.$store.myActions.ADM_ACTIVITY_ENSURE()    
    this.$store.myActions.ADM_FORFAIT_ENSURE()   
    this.loadPiscine()
  }

  mounted(){    
  }

  
  tarifAuCours(fft:AloForfait):number {    
    return fft.fftIsAbo?(fft.fftTarif! * fft.fftValiditeM!) / ((52 * fft.fftNbEntree! * fft.fftValiditeM!) / 12):fft.fftTarif!/fft.fftNbEntree!
  }  

  loadCours(){
    this.loadingCours = true
    this.coursIds = []
    const start = moment.utc()              
    this.$store.myActions.ADM_COURS_REQUEST({
        psnId : this.psnId,
        from :  new Date(start.toDate()),
        to:  new Date(start.add(this.nbSemaineGlissante,"week").toDate()),
        commit: CommitAction.dicOnly
      } as AlsCours).then((cours) => {
        this.coursIds = cours.map(c => c.id)
        this.min = formatDate(this.cours[0]?.crsDatdebut,"YYYY-MM-DD")
        this.date1 = formatDate(this.cours[0]?.crsDatdebut,"YYYY-MM-DD")
      })
      .finally(() => {      
        this.loadingCours = false
      })     
  }

  loadPiscine() {            
    this.loading = true    
    if(this.piscineId > 0) {
      this.$store.myActions.ADM_PISCINE_DETAIL_ENSURE(this.piscineId).then((piscine)=>{
        this.psnId = piscine.id     
        this.zoom = piscine.psnDomicile?10:13
        //Recupère les cours de la piscine
        this.loadCours()          
      })
      .finally(() => {      
        this.loading = false
      })    
    }
    else{
      this.$store.myActions.ADM_PISCINE_DETAIL_REQUEST(this.slug).then((piscine)=>{
        this.psnId = piscine.id
        this.zoom = piscine.psnDomicile?10:13
        //Recupère les cours de la piscine
        this.loadCours()   
      })
      .finally(() => {      
        this.loading = false
      })    
    }
  }

  addToCart(forfait:AloForfait) {
    this.$store.myActions.CLIENT_ADD_PANIER({item:forfait,qty:1,psnId:this.psnId})
    this.$confirm(this.$tc('App.ForfaitAddCart',1,{forfait:forfait.libelle,prix:formatCurrency(forfait.fftTarif!)})
                  ,{title: 'Ajout a votre panier',buttonTrueText:"Voir mon panier",buttonFalseText:"Continuer"} as VuetifyConfirmObject)
        .then((answer)=>{
          if(answer) this.$router.push({name:'Cart'})
        })
  }
  
  hasCours(date:String){
    return this.cours.findIndex(c => c.crsDatdebut.substring(0, 10) == date) > -1;
  }   
  
  selectPlanningActivity(acyIdPlanning:number) {
    this.acyIdPlanning = acyIdPlanning
    this.showAcyPlanningFilter = false
  }

  selectTarifActivity(acyIdTarif:number) {
    this.acyIdTarif = acyIdTarif
    this.showAcyTarifFilter = false
  }

  onNewInscription(){
    this.loadCours()
  }
  
  
  /*const zoneDomicileJson = []
  const zoneDomicileParse = this.zoneDomicileJson.map(it => ({com_name:it.fields.com_name,coordinates:(it.fields.geo_shape.coordinates.length == 1?it.fields.geo_shape.coordinates:it.fields.geo_shape.coordinates[it.fields.geo_shape.coordinates.length-1]).map(zone => zone.map(c => [c[1],c[0]] ))[0]}))  */
  
}
